import { Pipe, PipeTransform } from '@angular/core';
import { SecurityType } from "@models/shares/security-type";

@Pipe({
  name: 'shareTypePipe',
  standalone: true
})
export class ShareTypePipe implements PipeTransform {
  transform(value: string | null | undefined, htmlView = true): string {
    return ShareTypePipe.formatValue(value, htmlView);
  }

  static formatValue(identifier: string | null | undefined, htmlView = true): string {
    if (!identifier) return '';

    const parts = identifier.split('@');

    if (parts.length !== 2) {
      return identifier;
    }

    const [type, amount] = parts;

    const formattedAmount = amount.replace(/\$/g, '')
      .split('/')
      .map((part) => {
        const number = parseFloat(part);

        if (number) {
          return SecurityType.getMoneyLabel(number);
        }

        return null;
      })
      .filter((part) => part).join('/');

    return htmlView
      ? `<b>${ type }</b>@${ formattedAmount }`
      : `${ type }@${ formattedAmount }`;
  }
}
